module.exports = __webpack_public_path__ + "img/9788959760190.93569408.jpg";